<template>
  <a class="button-transparent" :href="hyperRef">
    <span class="button-transparent__text">{{ text }}</span>
    <img src="/static/images/arrow.svg" class="button-transparent__arrow" alt="&rarr;">
  </a>
</template>

<script>
  export default {
    name: "Button",
    props: {
      text: String,
      hyperRef: String
    }
  }
</script>


<style lang="stylus" scoped>
  @import '../../styles/tools'
  .button-transparent
    margin-top 10px
    box-sizing border-box
    display inline-flex
    justify-content center
    align-items center
    text-transform uppercase
    font-family AsketBold
    font-weight bold
    font-size 14px
    padding 20px 30px
    transition transform .3s
    color $white
    cursor pointer
    text-decoration none
    &:hover
      transform translateY(-5px)
    &__text
      margin-right 10px
    &__arrow
      margin-top -4px

</style>